import {IComponentController, ILogService, IScope} from "angular";
import {ActionService} from "../../../opportunity_actions_service/service/ActionService";
import {ACTION_SERVICE_NAME} from "../../../utils/names/serviceNames";
import {OpportunityAction, OpportunityActionBuilder} from "../../../opportunity_actions/model/OpportunityAction";
import {Opportunity} from "../../model/Opportunity";

interface OpportunityActionsScope extends IScope {
    opportunity: Opportunity;
    getIconUrl: (action: OpportunityAction) => string;
}


export class ActionsTooltips implements IComponentController {
    private $scope: OpportunityActionsScope;
    private actionsService: ActionService;
    private opportunity: Opportunity;
    private $log: ILogService;

    static instance = {
        template: require('./ActionsTooltips.html'),
        controller: ['$scope', ACTION_SERVICE_NAME, '$log', ActionsTooltips],
        bindings: {
            opportunity: '<'
        }
    };

    constructor($scope: OpportunityActionsScope, actionsService: ActionService, $log: ILogService) {
        $log.debug('Mounting actions tooltips component');
        this.actionsService = actionsService;
        this.$log = $log;
        this.$scope = Object.assign($scope, {
            getIconUrl: this.getIconUrl
        });
    }

    $onInit(): void {
        this.opportunity = this.opportunity;
        this.$log.debug('Finished mounting actions tooltips component');
        this.subscribeForOpportunityActions(this.opportunity);
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        let opportunityChanges = onChangesObj['opportunity'];
        this.opportunity = opportunityChanges.currentValue;
    }

    subscribeForOpportunityActions = (opportunity) => {
        // this.actionsService.getActionsObservable(
        //     new GroupedOpportunityKey(opportunity.customer.id, opportunity.condition.id)
        // )
        //     .pipe(
        //         groupBy(action => action.actionType),
        //         mergeMap((groupedActions: GroupedObservable<ActionTypes, OpportunityAction>) => {
        //             groupedActions.pipe(reduce((total,item)=> total+1,item ))
        //             let c = count(groupedActions);
        //                 return c.pipe(map(n => ({count: n, type: groupedActions.key})));
        //             }
        //         )
        //     )
        //     .subscribe(console.log);
    };

    getIconUrl = (action: OpportunityAction) => OpportunityActionBuilder(action).getIconUrl()

}